import { socketSend } from '@namespace/socket';

export const setAccountingLanguage = (lang) =>
  socketSend({
    cmd: 'accounting/set_language',
    cid: 'accounting/set_language',
    data: { language: lang }
  });
